exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-dl-btn {\n  cursor: pointer;\n  position: fixed;\n  bottom: 10px;\n  right: 10px;\n  background: #829ab0;\n  padding: 10px;\n  border-radius: 5px;\n  font-weight: bold;\n  color: #fff; }\n  .report-dl-btn.hol {\n    background: #f56600; }\n", ""]);

// exports
